import React, { useEffect, useState, useRef } from "react";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { WHITE, PRIMARY_LIGHT_BLUE } from "../../colors";
import HeightBox from "../../components/HeightBox";
import { AddifatNotMarriedPrintOut } from "../../components/Printouts/AffidatNotMarriedPrintOut";
import { useHistory } from "react-router-dom";
import CustomerService from "../../services/customerService";
import FormEditService from "../../services/formEditService";
import { AFFIDAVIT_NOT_MARRIED } from "../../constants/formTypes";
import { APPROVED, IN_DRAFT, NEW_FORM } from "../../constants/formStates";
import FormStateLabel from "./FormStateLabel";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F5F6F8",
  borderRadius: 10,
  paddingTop: 20,
  paddingLeft: 20,
  paddingBottom: 20,
  opacity: 0.9,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));
const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));
const CustomTextField = styled(TextField)(({ theme }) => ({
  width: 750,
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));
const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  minWidth: 155,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));
const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: "red",
  fontSize: 13,
}));

const initialValues = {
  fullName: "",
  birthday: "",
  nationalId: "",
  lieceneId: "",
  passport: "",
  passport_issued: "",
  spouse: "",
  district: "",
  secretarial: "",
  type: "",
  customer: "",
  address: "",
  village: "",
  religion: "",
};
export const AffidatNotMarried = (props) => {
  const [formValues, setFormValues] = useState(initialValues);
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const [pageInfo, setPageInfo] = useState({
    isDraft: false,
    isCreated: false,
  });
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  let history = useHistory();
  const handleSubmit = async () => {
    const res = submitAndPrint();
  };
  const submitAndPrint = async () => {
    try {
      if (!pageInfo.isCreated || (pageInfo.isCreated && !pageInfo.isDraft)) {
        const res = await FormEditService.createFormEdit(formValues);
      } else {
        const res = await FormEditService.updateFormEdit(props.customer, formValues);
      }

      alert("Successfully submitted the Application for Review");
      handlePrint();
      history.push("/forms");
      return true;
    } catch (e) {
      alert(e);
    }
  };

  useEffect(async () => {
    setIsDataLoaded(true);
    let newPageInfo = {
      isDraft: false,
      isCreated: false,
    };
    const getCustomer = async () => {
      const res = await CustomerService.getCustomerById(props.customer);
      return res.data;
    };
    const getFormDetails = async () => {
      const res = await FormEditService.getFormEditByCustomerAnType(props.customer, { type: AFFIDAVIT_NOT_MARRIED });
      return res.data;
    };

    let secretarialName;
    let districtName;
    let villageName;
    let religionName;
    try {
      const { id, isDraft, secretarial, religion, village, district } = await getFormDetails();
      secretarialName = secretarial;
      villageName = village;
      districtName = district;
      religionName = religion;
      newPageInfo = {
        isDraft,
        isCreated: true,
      };
    } catch (error) {}

    const {
      address,
      dob,
      full_name_sinhala,
      district,
      secretarial,
      village,
      region_sinhala,
      nic,
      license,
      passport,
      passport_issued,
    } = await getCustomer();

    setFormValues({
      ...formValues,
      fullName: full_name_sinhala,
      birthday: dob,
      lieceneId: license,
      customer: props.customer,
      nationalId: nic,
      type: AFFIDAVIT_NOT_MARRIED,
      passport,
      passport_issued,
      secretarial,
      village,
      district,
      address,
      religion: region_sinhala,
    });

    setPageInfo({ ...newPageInfo });
    setIsDataLoaded(false);
  }, [props.customer]);

  if (typeof props.customer !== "number") {
    return (
      <Container>
        <h2>Please select a customer</h2>
      </Container>
    );
  }
  return (
    <Container>
      <FormStateLabel type={pageInfo.isDraft ? IN_DRAFT : pageInfo.isCreated ? APPROVED : NEW_FORM} />
      <HeightBox height={20} />
      <div style={{ display: "none" }}>
        <AddifatNotMarriedPrintOut ref={componentRef} formValues={formValues} />
      </div>
      {isDataLoaded && (
        <Box
          sx={{
            width: "100%",
            height: "30vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      )}
      {!isDataLoaded && (
        <>
          <Stack direction="row" spacing={5}>
            <Stack direction="column" spacing={2}>
              <HeightBox height={4} />
              <CustomTypography>National Id</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>District</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Secretarial Division</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Village</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Religion</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Liecene Number</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Name</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Passport Number</CustomTypography>
              <HeightBox height={10} />
              <CustomTypography>Passport Issued Date</CustomTypography>
            </Stack>
            <Stack direction="column" spacing={2}>
              <CustomTextField
                value={formValues.nationalId}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.district}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    district: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.secretarial}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    secretarial: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.village}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    village: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.religion}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    religion: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
                required
              />
              <CustomTextField
                value={formValues.lieceneId}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                value={formValues.fullName}
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                value={formValues.passport}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    passport: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
              <CustomTextField
                type="date"
                value={formValues.passport_issued}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    passport_issued: e.target.value,
                  })
                }
                InputProps={{
                  disableUnderline: true,
                  readOnly: true,
                }}
              />
            </Stack>
          </Stack>

          <HeightBox height={20} />
          <Stack direction="row-reverse">
            <div style={{ width: 150 }} />
            {!pageInfo.isDraft && pageInfo.isCreated && (
              <CustomButton type="button" onClick={handlePrint}>
                Print{" "}
              </CustomButton>
            )}
            {!pageInfo.isDraft && pageInfo.isCreated && <CustomButton onClick={handleSubmit}>Submit </CustomButton>}
            {!pageInfo.isDraft && !pageInfo.isCreated && (
              <CustomButton onClick={handleSubmit}>Submit & Print </CustomButton>
            )}
          </Stack>
        </>
      )}
    </Container>
  );
};
